import { IApplicationState } from '../../../types/types';
import { ERoutes } from '../constants';

export const getMyWorkImportTab = (
    state: IApplicationState
): boolean => {
    return state.router.route === ERoutes.ASSIGNED_TO_ME_IMPORT;
}
